// extracted by mini-css-extract-plugin
export default {"root":"IconFilterList_root__vFSRo"};